import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChartHorizontalBarIcon = function ChartHorizontalBarIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0833 3.62484C12.0833 2.95749 11.5423 2.4165 10.8749 2.4165H6.04159C5.37424 2.4165 4.83325 2.95749 4.83325 3.62484C4.83325 4.29218 5.37424 4.83317 6.04159 4.83317L10.8749 4.83317C11.5423 4.83317 12.0833 4.29218 12.0833 3.62484ZM19.3333 8.45817C19.3333 7.79083 18.7923 7.24984 18.1249 7.24984L6.04159 7.24984C5.37424 7.24984 4.83325 7.79083 4.83325 8.45817C4.83325 9.12551 5.37424 9.6665 6.04158 9.6665L18.1249 9.6665C18.7923 9.6665 19.3333 9.12551 19.3333 8.45817ZM15.7083 12.0832C16.3756 12.0832 16.9166 12.6242 16.9166 13.2915C16.9166 13.9588 16.3756 14.4998 15.7083 14.4998H6.04159C5.37424 14.4998 4.83325 13.9588 4.83325 13.2915C4.83325 12.6242 5.37424 12.0832 6.04159 12.0832L15.7083 12.0832ZM21.7499 18.1248C21.7499 17.4575 21.2089 16.9165 20.5416 16.9165L6.04159 16.9165C5.37424 16.9165 4.83325 17.4575 4.83325 18.1248C4.83325 18.7922 5.37424 19.3332 6.04159 19.3332L20.5416 19.3332C21.2089 19.3332 21.7499 18.7922 21.7499 18.1248Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.20833 0C1.87568 0 2.41667 0.540989 2.41667 1.20833V20.5417C2.41667 21.209 1.87568 21.75 1.20833 21.75C0.540989 21.75 0 21.209 0 20.5417V1.20833C0 0.540989 0.540989 0 1.20833 0Z",
      fill: "#8C8C8C"
    })]
  }));
};

ChartHorizontalBarIcon.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartBarIcon = function ChartBarIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.62484 9.6665C2.95749 9.6665 2.4165 10.2075 2.4165 10.8748L2.4165 15.7082C2.4165 16.3755 2.95749 16.9165 3.62484 16.9165C4.29218 16.9165 4.83317 16.3755 4.83317 15.7082L4.83317 10.8748C4.83317 10.2075 4.29218 9.6665 3.62484 9.6665ZM8.45817 2.4165C7.79083 2.4165 7.24984 2.95749 7.24984 3.62484L7.24984 15.7082C7.24984 16.3755 7.79083 16.9165 8.45817 16.9165C9.12551 16.9165 9.6665 16.3755 9.6665 15.7082L9.6665 3.62484C9.6665 2.95749 9.12551 2.4165 8.45817 2.4165ZM12.0832 6.0415C12.0832 5.37416 12.6242 4.83317 13.2915 4.83317C13.9588 4.83317 14.4998 5.37416 14.4998 6.0415L14.4998 15.7082C14.4998 16.3755 13.9588 16.9165 13.2915 16.9165C12.6242 16.9165 12.0832 16.3755 12.0832 15.7082L12.0832 6.0415ZM18.1248 -0.000162811C17.4575 -0.000162782 16.9165 0.540828 16.9165 1.20817L16.9165 15.7082C16.9165 16.3755 17.4575 16.9165 18.1248 16.9165C18.7922 16.9165 19.3332 16.3755 19.3332 15.7082L19.3332 1.20817C19.3332 0.540828 18.7922 -0.00016284 18.1248 -0.000162811Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M-5.28179e-08 20.5417C-8.19885e-08 19.8743 0.540989 19.3333 1.20833 19.3333L20.5417 19.3333C21.209 19.3333 21.75 19.8743 21.75 20.5417C21.75 21.209 21.209 21.75 20.5417 21.75L1.20833 21.75C0.540989 21.75 -2.36474e-08 21.209 -5.28179e-08 20.5417Z",
      fill: "#8C8C8C"
    })]
  }));
};

ChartBarIcon.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const CHART_TYPES = [{
  value: 'vertical',
  label: 'Column',
  icon: /*#__PURE__*/_jsx(ChartBarIcon, {})
}, {
  value: 'horizontal',
  label: 'Bar',
  icon: /*#__PURE__*/_jsx(ChartHorizontalBarIcon, {})
}];